import React, { useEffect } from 'react';
import { useCSVStore, ValidationResults } from '../stores/csvStore';
import { CSVTable } from '../components/csv/CSVTable';
import AIAnalysisButton from '../components/csv/AIAnalysisButton';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import Sidebar from '../components/shared/Sidebar';
import { useNavigate } from 'react-router-dom';

// Use the provided API key
const GEMINI_API_KEY = "AIzaSyDHVGxMZ-bQjaQThsaYuZkmerosKT060B4";

const CSVDemoPage: React.FC = () => {
  const { setCSVData, setValidationResults, clearData } = useCSVStore();
  const navigate = useNavigate();
  
  // Log the API key on component mount
  useEffect(() => {
    console.log('GEMINI_API_KEY in CSVDemoPage:', GEMINI_API_KEY);
  }, []);

  // Sample CSV data with headers and rows
  const sampleCSVData = [
    ["Month", "Year", "Region", "Sales", "Revenue", "Expenses", "Profit"],
    ["January", "2025", "North", "1200", "6000", "3500", "2500"],
    ["February", "2025", "North", "1300", "6500", "3800", "2700"],
    ["March", "2025", "North", "1100", "5500", "3200", "2300"],
    ["January", "2025", "South", "950", "4750", "2900", "1850"],
    ["February", "2025", "South", "1050", "5250", "3100", "2150"],
    ["March", "2025", "South", "invalid", "5500", "3200", "2300"],
    ["January", "2025", "East", "850", "4250", "2500", "1750"],
    ["February", "2025", "East", "920", "4600", "NaN", "1900"],
    ["March", "2025", "East", "980", "4900", "2800", "2100"],
    ["January", "2025", "West", "750", "3750", "2200", "1550"],
    ["February", "2025", "West", "820", "4100", "2400", "1700"],
    ["March", "2025", "West", "880", "4400", "2600", "1800"],
    ["January", "2024", "North", "1100", "5500", "3300", "2200"],
    ["February", "2024", "North", "1200", "6000", "3600", "2400"],
    ["March", "2024", "North", "1000", "5000", "3000", "2000"]
  ];

  // Sample validation results 
  const sampleValidationResults: ValidationResults = {
    valid: false,
    errors: [
      {
        row: 6,
        column: "3",
        message: 'Value "invalid" in column "Sales" should be a number'
      },
      {
        row: 8,
        column: "5",
        message: 'Value "NaN" in column "Expenses" should be a number'
      }
    ],
    warnings: [
      {
        row: 10,
        column: "3",
        message: 'Sales value "750" for West region is below average (920)'
      }
    ]
  };

  const loadSampleData = () => {
    setCSVData(sampleCSVData);
    setValidationResults(sampleValidationResults);
  };

  const clearAll = () => {
    clearData();
  };

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="dashboard-page">
      <Sidebar />
      
      <div className="dashboard-main">
        <div className="dashboard-content">
          <div className="breadcrumbs">
            <button className="breadcrumb-link" onClick={goToDashboard}>
              Dashboard
            </button>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">CSV Demo</span>
          </div>
          
          <Box sx={{ my: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              CSV Validator Demo
            </Typography>

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Test Controls
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={loadSampleData}
                >
                  Load Sample Data
                </Button>

                <Button 
                  variant="outlined" 
                  color="secondary"
                  onClick={clearAll}
                >
                  Clear Data
                </Button>
              </Box>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                CSV Table with Validation
              </Typography>
              <CSVTable />
            </Paper>
            
            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Complete Data Analysis with Claude 3.7 Sonnet
              </Typography>
              <Typography paragraph>
                Click the button below to analyze your entire dataset with AWS Bedrock's Claude 3.7 Sonnet model to get comprehensive insights.
              </Typography>
              <div>
                <AIAnalysisButton 
                  prompt="As a financial analyst, thoroughly analyze this complete automotive financial dataset. Examine all rows and columns, looking for trends, patterns, and insights across regions, time periods, and key performance metrics. Provide detailed findings and highlight any significant correlations or anomalies."
                />
              </div>
            </Paper>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default CSVDemoPage; 